import React from "react";
import { useLocation } from "react-router-dom";
import { AppRoutes } from "./Navigation/AppRoutes";
import Footer from "./Components/Shared/Footer";
import AppNavbar from "./Components/Shared/AppNavbar";
import AdminSideBar from "./Components/Admin/Shared/AdminSideBar";
import { getAuthToken } from "./api/tokenHelper";
import { ToastContainer } from "react-toastify";
import SideFixed from "./Components/Shared/SideFixed";

function App() {
  const location = useLocation();
  const isLoggedIn = !!getAuthToken();

  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <React.Fragment>
      {isAdminRoute && isLoggedIn ? <AdminSideBar /> : <AppNavbar />}
      <AppRoutes />
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <SideFixed />}
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
